export default __webpack_public_path__ + "static/media/landing.b239f3d9.jpg";